<template>
  <v-row class="pa-sm-4">
    <v-col cols="12" lg="6" v-if="banners.length > 0">
      <!-- バナー -->
      <c-banners :banners="banners"/>
    </v-col>

    <!-- トピック -->
    <v-col cols="12" lg="6" v-if="topics.length > 0">
      <c-topics :topics="topics"/>
    </v-col>

    <v-col cols="12">
      <!-- ステーション一覧の凡例 -->
      <div v-if="hasFeatures" class="d-flex justify-end mb-4">
        <c-stations-legend :enables="features"/>
      </div>

      <!-- ステーション一覧 -->
      <v-row>
        <v-col
          v-for="st in mappedStations"
          :key="st.stationID"
          cols="12" sm="6" md="4" lg="3"
        >
          <c-station-card :features="features" :station="st"/>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import page from '@/mixins/page'
import CBanners from './CBanners'
import CTopics from './CTopics'
import CStationsLegend from './CStationsLegend'
import CStationCard from './CStationCard'

import * as api from '@/api'
import * as prefectures from '@/libs/prefectures'
import store from '@/store'

export default {
  name: 'Top',
  mixins: [
    page('')
  ],
  components: {
    CBanners,
    CTopics,
    CStationsLegend,
    CStationCard
  },

  async prepare (to) {
    const topURL = store.getters['org/top']
    console.log(topURL)
    if (topURL) {
      window.location.href = topURL
    }

    const orgcode = to.params.orgcode

    const companyID = to.query.c ? (to.query.c - 0) : 0
    const shopID = to.query.s ? (to.query.s - 0) : 0

    const params = {}
    if (shopID > 0) {
      params.shopID = shopID
    } else if (companyID > 0) {
      params.companyID = companyID
    }

    const results = await Promise.all([
      // バナー, トピックを取得する
      api.getOrg(orgcode, ['banners', 'topics']),

      // ステーション一覧を取得する
      api.getStations(orgcode, params)
    ])

    // 取得したデータを setData() に渡す
    return {
      org: results[0].data,
      stations: results[1].data
    }
  },

  props: {
    org: Object,
    stations: Array
  },

  computed: {
    // バナー
    banners () {
      return this.org.banners || []
    },

    // トピック
    topics () {
      return this.org.topics || []
    },

    hasFeatures () {
      return this.features.airport || this.features.station || this.features.keykey
    },

    // 表示すべき特徴
    features () {
      return enumFeatures(this.stations)
    },

    // 表示に適した形式に変換したステーション一覧
    mappedStations () {
      // this.stations の clone を作成する
      const stations = Array.from(this.stations)

      // stations を地域順にソートする
      stations.sort((x, y) => {
        if (x.profile.x0402 !== y.profile.x0402) {
          return x.profile.x0402 - y.profile.x0402
        }
        return x.stationID - y.stationID
      })

      // 表示に適した形式に変換する
      return mapStations(stations)
    }
  }
}

/**
 * 特徴を列挙する
 */
function getFeatures (meta) {
  return {
    airport: !!meta.airports,
    station: !!meta.stations,
    keykey: !!meta.services.keykey
  }
}

/**
 * 表示すべき特徴を列挙する
 *
 * @param {Array} data ステーション一覧
 * @returns {Array} 特徴一覧を返す
 */
function enumFeatures (data) {
  // ステーション全体で使用されている特徴を洗い出す
  return data.reduce((result, st) => {
    const feats = getFeatures(st.meta)
    return {
      airport: result.airport | feats.airport,
      station: result.station | feats.station,
      keykey: result.keykey | feats.keykey
    }
  }, {
    airport: false,
    station: false,
    keykey: false
  })
}

/**
 * 表示に適した形式に変換する
 *
 * @param {Array} data ステーション一覧
 * @returns {Array} 表示に適した形式でステーション一覧を返す
 */
function mapStations (data) {
  return data.map(st => ({
    stationID: st.stationID,
    shopID: st.shopID,

    name: st.profile.name,
    image: st.profile.image,

    x0402: st.profile.x0402,
    pref: prefectures.getName(st.profile.x0402),
    address: st.profile.address,
    phone: st.profile.phone,
    access: st.profile.access,
    map: st.profile.map,

    workTime: st.profile.workTime,

    features: getFeatures(st.meta)
  }))
}
</script>
